import { lazy } from 'react'

export default {
    path: '/consuntivi/:avanzamentoCasoId',
    title: 'Dettaglio consuntivi: {{params.avanzamentoCasoId}}',
    component: lazy(() => import('./detail'))
}